// Mock data for Glow Lawns Website
export const mockData = {
  // Stay Units
  stayUnits: [
    {
      id: 1,
      name: "MoonCanopy",
      type: "Tree House",
      description: "Where moonlight filters through ancient trees, painting silver dreams on wooden floors",
      price: 8500,
      capacity: 2,
      amenities: ["King Size Bed", "Private Balcony", "Forest View", "Hot Water", "WiFi"],
      images: [
        "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4",
        "https://images.unsplash.com/photo-1587061949409-02df41d5e562"
      ],
      available: true
    },
    {
      id: 2,
      name: "Forest Whisper",
      type: "Tree House",
      description: "Listen to nature's symphony in this elevated sanctuary among the canopy",
      price: 9000,
      capacity: 3,
      amenities: ["Queen Bed + Single", "Valley View", "Rain Shower", "Mini Fridge", "Reading Nook"],
      images: [
        "https://images.unsplash.com/photo-1596394516093-501ba68a0ba6",
        "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4"
      ],
      available: true
    },
    {
      id: 3,
      name: "Silver Grove",
      type: "Tree House",
      description: "A moonlit retreat where silence speaks louder than words",
      price: 8000,
      capacity: 2,
      amenities: ["Double Bed", "Hammock", "Waterfall View", "Organic Toiletries", "Coffee Maker"],
      images: [
        "https://images.unsplash.com/photo-1587061949409-02df41d5e562",
        "https://images.unsplash.com/photo-1596394516093-501ba68a0ba6"
      ],
      available: true
    },
    {
      id: 4,
      name: "Valley Light",
      type: "Tree House",
      description: "Watch the valley awaken with dawn's first light from your private perch",
      price: 9500,
      capacity: 4,
      amenities: ["Two Double Beds", "Large Deck", "Panoramic View", "Kitchenette", "Dining Area"],
      images: [
        "https://images.unsplash.com/photo-1501594907352-04cda38ebc29",
        "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4"
      ],
      available: true
    },
    {
      id: 5,
      name: "EarthNest",
      type: "Mud House",
      description: "Ground yourself in this earth-built sanctuary, where walls breathe with the forest",
      price: 7000,
      capacity: 2,
      amenities: ["Traditional Decor", "Natural Cooling", "Garden Access", "Eco-friendly", "Yoga Mat"],
      images: [
        "https://images.unsplash.com/photo-1542718610-a1d656d1884c",
        "https://images.unsplash.com/photo-1501594907352-04cda38ebc29"
      ],
      available: true
    }
  ],

  // Experiences
  experiences: [
    {
      id: 1,
      title: "Private Waterfall Bathing",
      description: "Immerse yourself in our secluded natural waterfall, surrounded by pristine forest",
      icon: "Droplets",
      included: true
    },
    {
      id: 2,
      title: "Moonrise Viewing",
      description: "Experience the magical moment as the moon rises over Moonrise Valley",
      icon: "Moon",
      included: true
    },
    {
      id: 3,
      title: "Forest Trails",
      description: "Guided or self-guided walks through ancient forest paths",
      icon: "TreePine",
      included: true
    },
    {
      id: 4,
      title: "Campfire Evenings",
      description: "Share stories under the stars with crackling fire and forest sounds",
      icon: "Flame",
      included: true
    },
    {
      id: 5,
      title: "Bird Watching",
      description: "Spot endemic Kerala birds in their natural habitat",
      icon: "Bird",
      included: true
    },
    {
      id: 6,
      title: "Village Tours",
      description: "Connect with local community and learn traditional Kerala lifestyle",
      icon: "Users",
      addon: true,
      price: 500
    }
  ],

  // Reviews
  reviews: [
    {
      id: 1,
      name: "Priya Menon",
      rating: 5,
      date: "2 weeks ago",
      text: "Absolutely magical! The tree house was stunning and the waterfall was our private paradise. The food was incredibly fresh and delicious. Will definitely return!",
      verified: true
    },
    {
      id: 2,
      name: "Rajesh Kumar",
      rating: 5,
      date: "1 month ago",
      text: "Perfect weekend getaway. The hospitality was warm, the forest setting peaceful, and watching the moonrise from our tree house was unforgettable. Highly recommend!",
      verified: true
    },
    {
      id: 3,
      name: "Sarah Thomas",
      rating: 5,
      date: "3 weeks ago",
      text: "This place exceeded all expectations. From the eco-friendly practices to the community engagement, everything was thoughtfully done. The silence and nature here heal the soul.",
      verified: true
    },
    {
      id: 4,
      name: "Amit Sharma",
      rating: 5,
      date: "2 months ago",
      text: "Took my family here for a long weekend. Kids loved the forest trails and waterfall. We adults loved the peace and the amazing Kerala cuisine. Safe and beautiful!",
      verified: true
    }
  ],

  // Gallery Images
  gallery: [
    {
      id: 1,
      url: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4",
      category: "accommodations",
      alt: "Tree House Exterior"
    },
    {
      id: 2,
      url: "https://images.unsplash.com/photo-1542718610-a1d656d1884c",
      category: "nature",
      alt: "Forest Path"
    },
    {
      id: 3,
      url: "https://images.unsplash.com/photo-1432405972618-c60b0225b8f9",
      category: "nature",
      alt: "Waterfall"
    },
    {
      id: 4,
      url: "https://images.unsplash.com/photo-1486915309851-b0cc1f8a0084",
      category: "experiences",
      alt: "Campfire Evening"
    },
    {
      id: 5,
      url: "https://images.unsplash.com/photo-1760638260957-cb88079c39ef",
      category: "dining",
      alt: "Outdoor Dining"
    },
    {
      id: 6,
      url: "https://images.unsplash.com/photo-1587061949409-02df41d5e562",
      category: "accommodations",
      alt: "Tree House Interior"
    },
    {
      id: 7,
      url: "https://images.unsplash.com/photo-1535332371349-a5d229f49cb5",
      category: "nature",
      alt: "Moonrise over Valley"
    },
    {
      id: 8,
      url: "https://images.unsplash.com/photo-1470549584009-d347338fc0ff",
      category: "experiences",
      alt: "Night Campfire"
    }
  ],

  // Events
  events: [
    {
      id: 1,
      title: "Intimate Weddings",
      description: "Exchange vows under the forest canopy with nature as your witness",
      capacity: "Up to 50 guests",
      icon: "Heart"
    },
    {
      id: 2,
      title: "Corporate Retreats",
      description: "Reconnect your team with nature and each other in a peaceful setting",
      capacity: "10-30 people",
      icon: "Briefcase"
    },
    {
      id: 3,
      title: "Wellness Retreats",
      description: "Yoga, meditation, and healing in harmony with the forest",
      capacity: "8-20 participants",
      icon: "Sparkles"
    },
    {
      id: 4,
      title: "Family Celebrations",
      description: "Birthdays, anniversaries, and special moments in a unique setting",
      capacity: "15-40 guests",
      icon: "Gift"
    }
  ],

  // Contact Info
  contact: {
    phone: "+91 99954 50101",
    whatsapp: "919995450101",
    email: "info@glowlawns.com",
    address: "Thotillpalam, Chappanthottam, Kozhikode, Kavilumpara, Kerala 673513",
    coordinates: { lat: 11.9416, lng: 75.9349 }
  }
};

export default mockData;
